import api from '@/utils/api';
import {
    GET_LIST_CUSTOMER_CARE_LOG,
    GET_SPECIFIC_CUSTOMER_CARE_LOG,
    UPDATE_SPECIFIC_CUSTOMER_CARE_LOG,
    CREATE_NEW_CUSTOMER_CARE_LOG,
    REMOVE_CUSTOMER_CARE_LOG
} from './types';
import { NotificationManager } from 'react-notifications';

/**
 * Lấy danh sách log CSKH theo khách hàng
 */
export const getCustomerCareLogsByCustomer = (filter, customerId) => dispatch => {
    return new Promise((resolve, reject) => {
        api.get(`/customer-care-logs/customer/${customerId}`, { params: filter })
            .then(res => {
                dispatch({
                    type: GET_LIST_CUSTOMER_CARE_LOG,
                    payload: res.data.data
                });
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error('Không thể tải danh sách CSKH của khách hàng');
                reject(err);
            });
    });
};

/**
 * Lấy bản ghi CSKH cụ thể theo ID
 */
export const getSpecificCustomerCareLog = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        api.get(`/customer-care-logs/${id}`)
            .then(res => {
                dispatch({
                    type: GET_SPECIFIC_CUSTOMER_CARE_LOG,
                    payload: res.data.data
                });
                resolve(res.data.data);
            })
            .catch(err => {
                NotificationManager.error(
                    err.response?.data?.msg || 'Không thể lấy chi tiết CSKH'
                );
                reject(err);
            });
    });
};

/**
 * Tạo mới log CSKH
 */
export const createCustomerCareLog = (customerId, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.post(`/customer-care-logs/customer/${customerId}`, data)
            .then(res => {
                dispatch({
                    type: CREATE_NEW_CUSTOMER_CARE_LOG,
                    payload: res.data.data
                });

                NotificationManager.success(res.data.msg || 'Tạo mới log CSKH thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể tạo mới log CSKH');
                reject(err);
            });
    });
};

/**
 * Cập nhật bản ghi CSKH
 */
export const updateCustomerCareLog = (customerId, id, data) => dispatch => {
    return new Promise((resolve, reject) => {
        api.put(`/customer-care-logs/customer/${customerId}/${id}`, data)
            .then(res => {
                dispatch({
                    type: UPDATE_SPECIFIC_CUSTOMER_CARE_LOG,
                    payload: res.data.data
                });

                NotificationManager.success(res.data.msg || 'Cập nhật log CSKH thành công!');
                resolve(res.data);
            })
            .catch(err => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Không thể cập nhật log CSKH');
                reject(err);
            });
    });
};

/**
 * Xoá một hoặc nhiều bản ghi CSKH
 */
export const removeCustomerCareLog = (ids) => dispatch => {
    return new Promise((resolve, reject) => {
        api.delete('/customer-care-logs', { data: { ids } })
            .then((res) => {
                dispatch({
                    type: REMOVE_CUSTOMER_CARE_LOG,
                    payload: ids
                });

                NotificationManager.success('Xoá log CSKH thành công!');
                resolve(res.data);
            })
            .catch((err) => {
                console.error(err);
                NotificationManager.error(err.response?.data?.msg || 'Xoá log CSKH thất bại');
                reject(err);
            });
    });
};
